import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import AboutPage from '../views/AboutPage.vue'
import GroupCollection from '../views/GroupCollection.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage
  },
  {
    path: '/group_collection',
    name: 'GroupCollection',
    component: GroupCollection
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router